import { defineMessages } from 'react-intl-next';

export default defineMessages({
    selectToEditAriaLabel: {
        id: 'company-hub.company-hub-common.items-shared.item-container.button.edit.aria-label',
        defaultMessage: "Select card to edit",
        description: 'Aira label for button that selects card for editing',
    },
});